import isEqual from 'lodash/isEqual';

import {
  getPointField,
} from "../../../../../../helpers/sqftHelper";
import sqftShapeManager from "../../../../store/sqftShapeManager";
import {SHAPE_PART_ID, SHAPE_ROTATE_DIRECTION} from "../../../../../../constants";
import SqftStore from "../../../../store/sqftStore";
import ShapeHelper from "../../../../../../helpers/shapeHelper";
import SeamToolRender from "./seamToolRender";
import SlabWorkspace from "../../../slab/slabWorkspace";
import SlabAdditionalShape from "../../../slab/slabAdditionalShape";
import {getHorizontalLineIntersectionPoints, getVerticalLineIntersectionPoints} from "./seamToolHelper";
import {createShapeFromPoints} from "../../../../../../helpers/freeDrawHelper";

class SeamTool {
  __shape;
  seamToolRender;

  constructor(_shape) {
    this.__shape = _shape;
    this.seamToolRender = new SeamToolRender(this);
  }

  getMaxLength = () => {
    //todo
    return 10
  }
  //todo
  addSeamPieceHorizontal = (mousePos) => {
    // const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
    // const serverState = store.getState().serverState;
    // const pos = this.__shape.getPosition();
    //let intersectionPoint1 = {x: -serverState.windowWidth, y: mousePosOnFiled.y - pos.y};
    //let intersectionPoint2 = {x: serverState.windowWidth, y: mousePosOnFiled.y - pos.y};

    let absoluteLinePoint1Pos = this.seamToolRender.absoluteLinePoint1Pos;
    let toPoint = {...mousePos};
    if (absoluteLinePoint1Pos && absoluteLinePoint1Pos.y) {
        let pf = getPointField(absoluteLinePoint1Pos.x, absoluteLinePoint1Pos.y, this.__shape);
        toPoint.y = pf.y;
    }
    const lines = this.__shape.getLines();
    console.log("linesPoints", lines.map((line) => { return {x: line.from.x, y: line.from.y}}));

    const linesWithoutAnglePoints = this.__shape.createLinesWithoutAngle();
    let [intersectionPointAndLine1, intersectionPointAndLine2] = getHorizontalLineIntersectionPoints(toPoint, this.__shape, linesWithoutAnglePoints);
    if (intersectionPointAndLine1 && intersectionPointAndLine2) {
      let seamShapesPoints = this.splitShape(linesWithoutAnglePoints, intersectionPointAndLine1, intersectionPointAndLine2, 'vertical');
      console.log("intersectionPoint1", intersectionPointAndLine1);
      console.log("intersectionPoint2", intersectionPointAndLine2);

      console.log("linesWithoutAnglePoints", linesWithoutAnglePoints.map((line) => { return {x: line.from.x, y: line.from.y}}));
      console.log("piece1Points", seamShapesPoints[0].map(point => { return {x: point.x, y: point.y}}));
      console.log("piece2Points", seamShapesPoints[1].map(point => { return {x: point.x, y: point.y}}));
      this.createShapesFromSeamPointsAndSetSlabRotation(seamShapesPoints);

      this.__shape.deregisterEvents();
      //this.__shape.shapeSlab.setRotationDegreesSlab(0); //? not needed
      SqftStore.addSeamHistory(this.__shape);
    } else {
      console.log("getHorizontalLineIntersectionPoints error missing intersections");
    }
  }

  createShapesFromSeamPointsAndSetSlabRotation = (seamShapesPoints) => {
    let parentShapeCenter = this.__shape.getCenter();

    for (let seamPoints of seamShapesPoints) {
      let isBacksplashPiece = [SHAPE_PART_ID.backsplashPiece, SHAPE_PART_ID.waterfallPiece].includes(this.__shape.partId);
      let partId = SHAPE_PART_ID.seamPiece;
      seamPoints = this.preparePointCords(seamPoints);
      let shapePieceId = createShapeFromPoints(seamPoints, partId, true);
      let shapePiece = sqftShapeManager.getShapeById(shapePieceId);
      shapePiece.featureId = this.__shape.featureId;
      shapePiece.featureName = this.__shape.featureName;
      shapePiece.colorSet = this.__shape.colorSet;
      shapePiece.deregisterPartEvents();
      let rotatedDiffPos = {x: 0, y: 0};

      if (isBacksplashPiece) {
        //add additional backsplash to slabWorkspace
        let parentSlabAdditionalShape = SlabWorkspace.slabAdditionalShapes.findOneByBacksplashShapeId(this.__shape.id);
        let newSlabAdditionalShape = new SlabAdditionalShape(parentSlabAdditionalShape.line, shapePieceId);
        SlabWorkspace.slabAdditionalShapes.addActiveBacksplash(newSlabAdditionalShape);
      }

      shapePiece.shapeSlab.setSlabPos(Object.assign({}, this.__shape.slabPos));
      if (this.__shape.rotatedDegreesSlab !== 0) {

        // this will rotate sqft and slab shape points to 0 it is required for correct rotation and drawing images in the right part
        let shapePieceCenterPointBeforeRotation = ShapeHelper.getCenterPoint(shapePiece.getLines().map(line => line.from));
        let reqRotatedDegreesToZero = 360 - this.__shape.rotatedDegreesSlab;
        //console.log("piece before rotate1", shapePiece.getLines().map((line) => { return {x: line.from.x, y: line.from.y}}));
        shapePiece.rotate(reqRotatedDegreesToZero, SHAPE_ROTATE_DIRECTION.left, true, parentShapeCenter);
        //console.log("piece rotate2", shapePiece.getLines().map((line) => { return {x: line.from.x, y: line.from.y}}));
        shapePiece.rotate(360, SHAPE_ROTATE_DIRECTION.left, false, parentShapeCenter);
        //console.log("piece rotate3", shapePiece.getLines().map((line) => { return {x: line.from.x, y: line.from.y}}));
        shapePiece.setRotationDegrees(0);
        shapePiece.shapeSlab.setRotationDegreesSlab(0);

        //rotate shape and move it to diff position (this is for correct displaying right part)
        shapePiece.rotate(this.__shape.rotatedDegreesSlab, SHAPE_ROTATE_DIRECTION.left, true);
        let shapePieceCenterPointAfterRotation = ShapeHelper.getCenterPoint(shapePiece.getLines().map(line => line.from));
        this.__shape.setIsPointsChanged(false); // prevent points change after rotation
        console.log("piece rotate4", shapePiece.getLines().map((line) => { return {x: line.from.x, y: line.from.y}}));

        rotatedDiffPos = {
          x: shapePieceCenterPointBeforeRotation.x - shapePieceCenterPointAfterRotation.x,
          y: shapePieceCenterPointBeforeRotation.y - shapePieceCenterPointAfterRotation.y,
        }
      }
      let coreShapeAbsolutePosition = this.__shape.getSlabAbsolutePosition()
      let slabAbsolutePosition = coreShapeAbsolutePosition ? coreShapeAbsolutePosition : this.__shape.getSlabPosition();
      shapePiece.slabPos = {
        x: slabAbsolutePosition.x + rotatedDiffPos.x,
        y: slabAbsolutePosition.y + rotatedDiffPos.y,
      }

      shapePiece.shapeSlab.setParentId(this.__shape.id); //this is not needed  maybe in future
      shapePiece.setPosition(Object.assign({}, this.__shape.getRegularPosition()));

      this.__shape.addShapePieceId(shapePiece.id);
    }
  };

  addSeamPieceVertical = (mousePos) => {
    // const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
    // const serverState = store.getState().serverState;
    // const pos = this.__shape.getPosition();
    //
    // let intersectionPoint1 = {x: mousePosOnFiled.x - pos.x, y: -serverState.windowHeight};
    // let intersectionPoint2 = {x: mousePosOnFiled.x - pos.x, y: serverState.windowHeight};
    let absoluteLinePoint1Pos = this.seamToolRender.absoluteLinePoint1Pos;
    let toPoint = {...mousePos};
    if (absoluteLinePoint1Pos && absoluteLinePoint1Pos.x) {
      let pf = getPointField(absoluteLinePoint1Pos.x, absoluteLinePoint1Pos.y, this.__shape);
      toPoint.x = pf.x;
    }
    const linesWithoutAnglePoints = this.__shape.createLinesWithoutAngle();
    let [intersectionPointAndLine1, intersectionPointAndLine2] = getVerticalLineIntersectionPoints(toPoint, this.__shape, linesWithoutAnglePoints);

    if (intersectionPointAndLine1 && intersectionPointAndLine2) {
      let seamShapesPoints = this.splitShape(linesWithoutAnglePoints, intersectionPointAndLine1, intersectionPointAndLine2, 'horizontal');
      // console.log("intersectionPoint1", intersectionPointAndLine1);
      // console.log("intersectionPoint2", intersectionPointAndLine2);
      // console.log("shapePoints", this.__shape.getLines().map((line) => { return {x: line.from.x, y: line.from.y}}));
      // console.log("piece1Points", seamShapesPoints[0].map(point => { return {x: point.x, y: point.y}}));
      // console.log("piece2Points", seamShapesPoints[1].map(point => { return {x: point.x, y: point.y}}));
      this.createShapesFromSeamPointsAndSetSlabRotation(seamShapesPoints);

      this.__shape.deregisterEvents();
      //this.__shape.shapeSlab.setRotationDegreesSlab(0); //? not needed
      SqftStore.addSeamHistory(this.__shape);
    } else {
      console.log("getVerticalLineIntersectionPoints error missing intersections");
    }
  };

  preparePointCords = (seamPoints) => {
    return seamPoints.map((seamPoint) => {
      seamPoint.x = Math.round10(seamPoint.x, -1);
      seamPoint.y = Math.round10(seamPoint.y, -1);
      return seamPoint
    })
  };

  /**
   * @param {[]} lines
   * @param {*} intersectionPointAndLine1
   * @param {*} intersectionPointAndLine2
   * @param {string} splitOnlyOrientation
   */
  splitShape = (lines, intersectionPointAndLine1, intersectionPointAndLine2, splitOnlyOrientation) => {
    let piece1Points = [];
    let piece2Points = [];
    let intersectionNumber = 1;
    let lastPoint;
    let intersectionPoint1 = intersectionPointAndLine1.intersectionCords
    let intersectionPoint2 = intersectionPointAndLine2.intersectionCords

    lines.forEach((line) => {
      let intersectionCords = null;
      void splitOnlyOrientation;

      // version 1.0 search cords again
      //if (line.getLineDirection().orientation === splitOnlyOrientation || !splitOnlyOrientation) {
        // intersectionCords = getIntersectCords(
        //   Math.round10(line.from.x, -1), Math.round10(line.from.y, -1),
        //   Math.round10(line.to.x, -1), Math.round10(line.from.y, -1),
        //   Math.round10(intersectionPoint1.x, -1), Math.round10(intersectionPoint1.y, -1),
        //   Math.round10(intersectionPoint2.x, -1), Math.round10(intersectionPoint2.y,-1),
        //   false
        // )
      //}

      // version 2.0 use existing intersection cords
      if ((line === intersectionPointAndLine1.line || line === intersectionPointAndLine2.line)) {
        intersectionCords = line === intersectionPointAndLine1.line
          ? intersectionPointAndLine1.intersectionCords
          : intersectionPointAndLine2.intersectionCords
      }

      if (intersectionCords) {
        let ip = (Math.round10(intersectionCords.x, -1) === Math.round10(intersectionPoint1.x, -1)
          && Math.round10(intersectionCords.y, -1) === Math.round10(intersectionPoint1.y, -1))
          ? intersectionPoint1 : intersectionPoint2
        if (piece2Points.length === 1) { // triangle shape
          piece2Points.push(line.from);
        }
        const nextLine = line.getParent().getNextLine(line, undefined, true);
        if (piece1Points.length === 1
          && (nextLine.id === intersectionPointAndLine1.line.id || nextLine.id === intersectionPointAndLine2.line.id)
        ) {
          piece1Points.push(line.to); // triangle shape
        }
        piece1Points.push(ip);
        piece2Points.push(ip);
      } else {
        if (intersectionNumber % 2 !== 0) {
          lastPoint = piece1Points[piece1Points.length - 1];
          if (!lastPoint || !lastPoint.id || lastPoint.id !== line.from.id) {
            piece1Points.push(line.from);
          }
          if (piece1Points[0] !== line.to) {
            piece1Points.push(line.to);
          }
        }
        if (intersectionNumber % 2 === 0) {
          lastPoint = piece2Points[piece2Points.length - 1];
          if (!lastPoint || !lastPoint.id || lastPoint.id !== line.from.id) {
            piece2Points.push(line.from);
          }
          if (piece2Points[0] !== line.to) {
            piece2Points.push(line.to);
          }
        }
      }

      if (intersectionCords) {
        intersectionNumber += 1;
      }
      //console.log("intersectionCords", intersectionCords);
    });
    //console.log("piece1Points before filter", piece1Points.map(point => { return {x: point.x, y: point.y}}));
    //console.log("piece2Points before filter", piece2Points.map(point => { return {x: point.x, y: point.y}}));

    function filterEqualAndPointsOnTheSameLine(pointsArray) {
      return pointsArray.filter((point, index, array) => {
        let prev = array[index - 1];
        let next = array[index + 1];
        if (!prev) { // include first point
          prev = array[array.length - 1];
        }
        if (!next) {
          next = array[0]; // next point for the last point in array is the first point in array
        }
        const isEqualPoints = isEqual({x: point.x, y: point.y}, {x: prev.x, y: prev.y});
        const isOnTheSameLine = point.x === prev.x && point.x === next.x || point.y === prev.y && point.y === next.y
        return !isEqualPoints && !isOnTheSameLine
      })
    }

    return [filterEqualAndPointsOnTheSameLine(piece1Points), filterEqualAndPointsOnTheSameLine(piece2Points)]
  }
}

export default SeamTool
